export default(column_name, lang) => {
    
    
    let CompanyControlParametersOption = {
        ADDING_OPTIONS: [
            // 通話録音オプション
            {
                name: "call_record_option",
                label: `${lang.CallRecordingOptionLabel}`,
                function_id: "CALL_RECORD",
                parameter_id: "CALL_RECORD_OPTION",
                parameter_value: "Y",
                memo: `${lang.CallRecordingOptionAllowed}`,
                description: `${lang.CallRecordDescription}`
            },
            // IVRオプション
            {
                name: "ivr_option",
                label: `${lang.IvrOptionLabel}`,
                function_id: "BUSINESS_CALENDAR",
                parameter_id: "SCRIPT_SELECT",
                parameter_value: "N",
                memo: `${lang.IvrOptionAllowed}`,
                description: `${lang.IvrDescription}`
            },
            // IVR多言語翻訳機能オプション
            {
                name: "ivr_translate_option",
                label: `${lang.OptionLabelTree + lang.IvrTranslateOptionLabel}`,
                function_id: "TRANSLATE",
                parameter_id: "TRANSLATE_OPTION",
                parameter_value: "N",
                memo: `${lang.IvrTranslateOptionAllowed}`,
                description: `${lang.IvrTranslateDescription}`
            },
            // 通話履歴オプション
            {
                name: "call_analysis_option",
                label: `${lang.CallAnalysisOptionLabel}`,
                function_id: "CALL_ANALYSIS",
                parameter_id: "CALL_ANALYSIS_OPTION",
                parameter_value: "N",
                memo: `${lang.CallAnalysisOptionAllowed}`,
                description: `${lang.CallAnalysisDescription}`
            },
            // 音声品質分析API選択オプション
            {
                name: "call_analysis_api_option",
                label: `${lang.CallAnalysisApiOptionLabel}`,
                function_id: "CALL_ANALYSIS_API",
                parameter_id: "CALL_ANALYSIS_API_OPTION",
                parameter_value: lang.call_analysis_api_select[0].value,
                memo: `${lang.CallAnalysisApiOptionAllowed}`,
                select_option: lang.call_analysis_api_select,
                description: `${lang.CallAnalysisApiDescription}`
            },
            // 通話分類タグ
            {
                name: "call_auto_tag_option",
                label: `${lang.OptionLabelTree + lang.CallAutoTagOptionLabel}`,
                function_id: "CALL_AUTO_TAG",
                parameter_id: "CALL_AUTO_TAG_OPTION",
                parameter_value: "N",
                memo: `${lang.CallAutoTagOptionAllowed}`,
                description: `${lang.CallAutoTagDescription}`
            },
            // 応対品質オプション
            {
                name: "call_eval_option",
                label: `${lang.OptionLabelTree + lang.CallEvalOptionLabel}`,
                function_id: "CALL_EVAL",
                parameter_id: "CALL_EVAL_OPTION",
                parameter_value: "N",
                memo: `${lang.CallEvalOptionAllowed}`,
                description: `${lang.CallEvalDescription}`
            },
            // ACD機能オプション
            {
                name: "acd_option",
                label: `${lang.AcdOptionLabel}`,
                function_id: "ACD_FUNCTION",
                parameter_id: "ACD_FUNCTION_OPTION",
                parameter_value: "N",
                memo: `${lang.AcdOptionAllowed}`,
                description: `${lang.AcdDescription}`
            },
            // コール結果オプション
            {
                name: "call_result_option",
                label: `${lang.CallResultOptionLabel}`,
                function_id: "CALL_RESULT_RANK",
                parameter_id: "CALL_RESULT_RANK_OPTION",
                parameter_value: "N",
                memo: `${lang.CallResultOptionAllowed}`,
                description: `${lang.CallResultDescription}`
            },
            // 自動受電オプション
            {
                name: "auto_reception_option",
                label: `${lang.AutoReceptionOptionLabel}`,
                function_id: "AUTO_RECEPTION",
                parameter_id: "AUTO_RECEPTION_OPTION",
                parameter_value: "N",
                memo: `${lang.AutoReceptionOptionAllowed}`,
                description: `${lang.AutoReceptionDescription}`
            }

        ],
        // 追加オプションラジオボタンの情報
        ADDING_OPTION_SETTING_VALUE_INFOS : [
            {value :"Y",label:"ON"},
            {value :"N",label:"OFF"}
        ],
        // 各画面でデータ変更時に実行される機能
        FUNCTION_WHEN_DATA_IS_CHANGED_IN_SCREEN : [
            {
                function_id: "SHOW_ADDING_CONFIRMATION_POPUP",
                parameter_id: "OPTION",
                parameter_value: "N",
                memo: `${lang.ShowAddingConfirmationPopupAllowed}`
            },
            {
                function_id: "SEND_MAIL_WHEN_DATA_IS_CHANGED_IN_SCREEN",
                parameter_id: "OPTION",
                parameter_value: "N",
                memo: `${lang.SendMailWhenDataIsChangedAllowed}`
            },
            {
                function_id: "SEND_MAIL_WHEN_DATA_IS_CHANGED_IN_SCREEN",
                parameter_id: "SEND_MAIL_ADDRESS_TO",
                parameter_value: "",
                memo: `${lang.SendMailAddressToWhenDataIsChanged}`
            },
            {
                function_id: "SEND_MAIL_WHEN_DATA_IS_CHANGED_IN_SCREEN",
                parameter_id: "SEND_MAIL_ADDRESS_CC",
                parameter_value: "",
                memo: `${lang.SendMailAddressCcWhenDataIsChanged}`
            },
            {
                function_id: "SEND_MAIL_WHEN_DATA_IS_CHANGED_IN_SCREEN",
                parameter_id: "SEND_MAIL_ADDRESS_BCC",
                parameter_value: "",
                memo: `${lang.SendMailAddressBccWhenDataIsChanged}`
            }
        ]
    };

    return CompanyControlParametersOption[column_name];
}
